import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loader } from '@components/Loader';
import { Layout } from '@account_module/components/Layout';

export const AccountPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/account/settings', { replace: true });
  }, []);

  return (
    <Layout.Background>
      <Loader size='lg' theme='light' />
    </Layout.Background>
  );
};
